import type { BariPreMedConsultReportData } from '@common/validation/customControls/bariPre/bariPreMedConsultReport/v1/bariPreMedConsultReportSchemaV1';

export const initialData: BariPreMedConsultReportData = {
    abdominaal: null,
    alcohol: null,
    ander_onderzoek: false,
    bloeddruk_diastolisch: null,
    bloeddruk_systolisch: null,
    buikomvang: null,
    cardiologisch_onderzoek: false,
    dm: null,
    drugs: null,
    extremiteiten: null,
    gewicht_in_kg: null,
    hart: null,
    hartfalen: null,
    hvz: null,
    hypertensie: null,
    lengte_in_cm: null,
    littekens: null,
    longfunctieonderzoek: false,
    medicatie: null,
    medische_voorgeschiedenis: null,
    onderzoek_interne_geneeskunde: false,
    overgewicht: null,
    pols: null,
    pulmonaal: null,
    roken: null,
    slaaponderzoek: false,
    souffles: null,
    speciele_anamnese: null,
    toelichting_alcohol: null,
    toelichting_ander_onderzoek: null,
    toelichting_cardiologisch_onderzoek: null,
    toelichting_dm: null,
    toelichting_drugs: null,
    toelichting_hartfalen: null,
    toelichting_hvz: null,
    toelichting_hypertensie: null,
    toelichting_longfunctieonderzoek: null,
    toelichting_medicatie: null,
    toelichting_onderzoek_interne_geneeskunde: null,
    toelichting_overgewicht: null,
    toelichting_roken: null,
    toelichting_slaaponderzoek: null,
    vag: null,
};
